// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jq-1";
export var messageSideRight = "_jq-2";
export var orderLookupBubbleContainer = "_jq-0";
export var submitButton = "_jq-3";